import { toast } from "react-toastify";
import { CONVERSATION_MATRIX } from "../config/apiEndPoint";
import { GET, POST, PUT, DEL } from "config/api.config";

export const fetchConversationMatrixTableAndFilterSchema = async (data = {}) => {
  try {
    const response = await GET(CONVERSATION_MATRIX.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitConversationMatrixFilterData = async (data = {}) => {
  try {
    const response = await POST(CONVERSATION_MATRIX.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addConversationMatrix = async (data = {}) => {
  try {
    const response = await POST(CONVERSATION_MATRIX.LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateConversationMatrix = async (id, data = {}) => {
  try {
    const response = await PUT(CONVERSATION_MATRIX.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const deleteConversationMatrix = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("Record ID is required");
    return;
  }
  try {
    const response = await DEL(CONVERSATION_MATRIX.BY_ID(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchConversationMatrixByGroup = async (groupId = "") => {
  const raw = String(groupId ?? "").trim();
  if (!raw) {
    return null;
  }
  try {
    const response = await GET(CONVERSATION_MATRIX.BY_GROUP(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchConversationMatrixStages = async () => {
  try {
    const response = await GET(CONVERSATION_MATRIX.STAGES);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchConversationMatrixTemplates = async () => {
  try {
    const response = await GET(CONVERSATION_MATRIX.TEMPLATES);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `conversation-schedule-matrix` — create (no id) or update (with id). */
export const submitConversationMatrixBulk = async (rows = []) => {
  try {
    const response = await POST(CONVERSATION_MATRIX.LIST, rows);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
